<template>
  <div class="hq-display-block">
    <v-dialog v-model="showWithdraw" width="600">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-icon color="primary" @click="showWithdraw = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <manual-withdraw
            :title="'Withdraw P24 Listing'"
            :close-edit.sync="showWithdraw"
            :refreshTable.sync="dataChanged"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row class="hq-details-row">
      <v-col cols="4" class="hq-main-title-card">
        <div>
          <a href="#" class="goback">
            <v-icon color="#5E5873">mdi-arrow-left</v-icon>Back</a
          >

          <div class="breadcrumb-block">
            <a href="/admin/dashboard" class="breadcrumb-link-home">Home</a>
            <v-icon>mdi-chevron-right</v-icon>
            <a href="#" class="breadcrumb-link">Listing Admin</a>
          </div>

          <h1 class="heading">P24 and Website Listings</h1>
          <div>
            <strong style="color: #5e5873"></strong>
          </div>
        </div>
      </v-col>

      <v-col cols="16">
        <v-row>
          <v-col cols="3" class="mt-3">
            <v-card class="mx-auto new-note-card" flat>
              <v-list-item>
                <v-list-item-title class="text-h5 text-center">
                  Active P24 Listings
                </v-list-item-title>
              </v-list-item>

              <v-card-text>
                <v-row align="center">
                  <v-col class="text-h2 text-center" v-if="portals">
                    {{ portals.count }}
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3" class="mt-3">
            <v-card class="mx-auto new-note-card" flat>
              <v-list-item>
                <v-list-item-title class="text-h5 text-center">
                  P24 Agents
                </v-list-item-title>
              </v-list-item>

              <v-card-text>
                <v-row align="center">
                  <v-col class="text-h2 text-center">
                    {{ users?.records?.length }}
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3" class="mt-3">
            <v-card class="mx-auto new-note-card" flat>
              <v-list-item>
                <v-list-item-title class="text-h5 text-center">
                  {{ thismonthlong }} Leads
                </v-list-item-title>
              </v-list-item>
              <v-card-text>
                <v-row align="center">
                  <v-col class="text-h2 text-center"> 0 </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="3" class="mt-3">
            <v-card class="mx-auto new-note-card" flat>
              <v-list-item>
                <v-list-item-title class="text-h5 text-center">
                  Stats
                </v-list-item-title>
              </v-list-item>
              <v-card-text>
                <v-row align="center">
                  <v-col class="text-h2 text-center"> 0% </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <base-loader-bar :is-loading="isLoading" />

    <!-- Tabs Row -->
    <v-row class="hqSectTab">
      <v-col cols="12">
        <v-tabs fixed-tabs v-model="tab">
          <v-tabs-slider color="#069697 "></v-tabs-slider>
          <v-tab
            class="hq-tabs"
            v-for="(tab, i) in vstabs"
            :key="i"
            :class="'top-table-nav tab-' + i"
          >
            {{ tab }}
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <!-- /Tabs Row -->

    <!-- <v-tab-item> -->

    <v-tabs-items v-model="tab">
      <!-- Start Listings Tab -->
      <v-tab-item>
        <!-- <div class="for-props leadSwitch longer mb-3 pt-0">
          <span>{{ `Show ${showNewListings ? "Old" : "New"} Listing` }}</span>
          <v-switch
            v-model="showNewListings"
            hide-details
            color="primary"
            inset
          />
        </div> -->
        <div v-if="showNewListings">
          <div class="expand-filter-block">
            <listing-filter :listingFilters.sync="listingOptions" />
          </div>

          <listing-section
            :listingOptions="listingOptions"
            :passedPageLimit="50"
            :showWithdraw="true"
          />
        </div>
        <portal-table-section v-else />
      </v-tab-item>
      <!-- End Listings Tab -->

      <!-- Start Agents Tab -->
      <v-tab-item>
        <admin-section :isAgentView="true" />
      </v-tab-item>
      <!-- End Agents Tab -->

      <!-- Start Leads Tab -->
      <v-tab-item>
        <base-under-construction />
      </v-tab-item>
      <!-- End Leads Tab -->

      <!-- Start Settings Tab -->
      <v-tab-item>
        <base-under-construction />
      </v-tab-item>
      <!-- End Settings Tab -->
    </v-tabs-items>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import defaultProfile from "../../../assets/img/avatar.png";
import ContactPicker from "../../../components/Base/Pickers/ContactPicker.vue";
import PortalagentCreate from "../../../components/Base/Contact/PortalagentCreate";
import ManualWithdraw from "../../../components/Base/P24/ManualWithdraw";
import PortalTableSection from "@/components/Base/Property/PropertyBlocks/BuildingBlocks/PortalTableSection";
import moment from "moment";

import { GET_USERS_FULL } from "@/queries/user";

import AdminSection from "@/components/Base/User/AdminSection.vue";
import ListingSection from "@/components/Base/Listings/ListingSection";
import ListingFilter from "@/components/Base/Listings/ListingFilter";
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    editType: {
      type: String,
      default: "default",
    },
    toshow: {
      type: String,
      default: "",
    },
  },
  components: {
    defaultProfile,
    ContactPicker,
    PortalagentCreate,
    ManualWithdraw,
    AdminSection,
    PortalTableSection,
    ListingFilter,
    ListingSection,
  },
  data() {
    return {
      portaltest: [{ id: "6531988768ea5c50908c6fba", name: "Building 1" }],
      showAddAgent: false,
      showWithdraw: false,
      dataChanged: null,
      isLoading: true,
      maxPortfolio: null,
      users: [],
      url: null,
      image: null,
      base64: null,
      error: null,
      refreshTable: null,
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      sortBy: "status",
      sortDesc: false,
      expanded: [],
      tab: null,
      vstabs: ["Listings", "Agents", "Leads", "Settings"],
      search: false,
      search1: "",
      withdrawID: "",
      selectedID: null,
      portals: null,
      agents: [],
      show: false,
      listingOptions: {},
      showNewListings: true,
    };
  },

  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,

    portals: {
      query: gql`
        query portals($limit: Int!, $skip: Int!, $query: JSON!, $sort: JSON) {
          portals(limit: $limit, skip: $skip, query: $query, sort: $sort) {
            records {
              id
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const self = this;
        const limit = 9999;
        const skip = 0;

        // name
        //       status
        //       saleRental
        //       p24Id
        //       building
        //       propertyType
        //       floorSize
        //       price
        //       queueDate
        //       expiry
        //       auction
        //       headline
        //       website
        //       property24
        //       p24Agent {
        //         id
        //         firstName
        //         lastName
        //       }
        //       propertyId {
        //         id
        //         address
        //       }

        return {
          limit: limit,
          skip: skip,
          query: { fieldLimit: "_id" },
          sort: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },

    users: {
      query: GET_USERS_FULL,
      fetchPolicy: "network-only",
      variables() {
        const self = this;
        const limit = 10;

        let agentFilter = {}; // Initialize agentFilter
        agentFilter = {
          p24Agentid: { $exists: true } && { $ne: null },
          p24Status: true,
        }; // Show Only Agents on Portal View

        return {
          limit: limit,
          page: this.page,
          query: {
            $and: [agentFilter],
          },
          sort: { createdAt: -1 },
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
  },

  computed: {
    datenow() {
      return moment().format("YYYY-MM-DD");
    },
    thismonthlong() {
      return moment().format("MMMM 'YY");
    },

    thismonth() {
      return moment().format("MMM 'YY");
    },

    lastmonth() {
      return moment().subtract(1, "months").format("MMM 'YY");
    },
  },

  methods: {
    contactsFilters() {},

    //// Start Image to Base64 Converter
    getBase64Image(img) {
      console.log("cek base64 : ", btoa(img));
      return `data:image/jpeg;base64,${btoa(img)}`;
    },

    createBase64Image: function (FileObject) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.base64 = event.target.result;
      };
      reader.readAsDataURL(FileObject);
    },
    //// Start Image to Base64 Converter

    refreshportal() {
      this.$apollo.queries.portals.refetch();
    },

    directwithdrawold(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, withdraw P24 Listing!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.query({
              query: gql`
                query ($p24id: String!) {
                  p24Withdraw(p24id: $p24id) {
                    p24id
                  }
                }
              `,
              variables: {
                p24id: item,
              },
            });

            console.log("Withdraw Status Change");

            if (response) {
              this.$swal(
                "Success!",
                "P24 Listing " + item + " was successfully withdrawn",
                "success"
              );
              this.$apollo.queries.portals.refetch();
            }
          } catch (e) {}
        }
      });
    },

    directwithdraw(item) {
      if (this.withdrawID) {
        this.item = this.withdrawID;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, withdraw P24 Listing!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.query({
              query: gql`
                query ($p24id: String!) {
                  p24Withdraw(p24id: $p24id) {
                    p24id
                  }
                }
              `,
              variables: {
                p24id: item,
              },
            });

            await this.$apollo.mutate({
              mutation: gql`
                mutation update($portal: PortalwdUpdateInput!) {
                  updatewdPortal(portal: $portal) {
                    id
                  }
                }
              `,
              variables: {
                portal: {
                  //id: item.id,
                  p24Id: item,
                  // updatedBy: self.me.id,
                  updatedAt: parseFloat(new Date().getTime()),
                  status: "Withdrawn",
                },
              },
            });

            console.log("Withdraw Status Change");

            if (response) {
              this.$swal(
                "Success!",
                "P24 Listing " + item.p24Id + " was successfully withdrawn",
                "success"
              );
              this.$apollo.queries.portals.refetch();
            }
          } catch (e) {}
        }
      });
    },

    withdraw(item) {
      if (this.withdrawID) {
        this.item.p24Id = this.withdrawID;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, withdraw P24 Listing!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.query({
              query: gql`
                query ($p24id: String!) {
                  p24Withdraw(p24id: $p24id) {
                    p24id
                  }
                }
              `,
              variables: {
                p24id: item.p24Id,
              },
            });

            await this.$apollo.mutate({
              mutation: gql`
                mutation update($portal: PortalUpdateInput!) {
                  updatePortal(portal: $portal) {
                    id
                  }
                }
              `,
              variables: {
                portal: {
                  id: item.id,
                  p24Id: item.p24Id,
                  // updatedBy: self.me.id,
                  updatedAt: parseFloat(new Date().getTime()),
                  status: "Withdrawn",
                },
              },
            });

            console.log("Withdraw Status Change");

            if (response) {
              this.$swal(
                "Success!",
                "P24 Listing " + item.p24Id + " was successfully withdrawn",
                "success"
              );
              this.$apollo.queries.portals.refetch();
            }
          } catch (e) {}
        }
      });
    },

    Contact() {},
    clickColumn(slotData) {
      const indexRow = slotData.index;
      const indexExpanded = this.expanded.findIndex((i) => i === slotData.item);
      if (indexExpanded > -1) {
        this.expanded.splice(indexExpanded, 1);
      } else {
        this.expanded.push(slotData.item);
      }
    },

    ToggleClose(tohide) {
      document.querySelector(tohide)?.classList.remove("show");
      document.querySelector(tohide)?.classList.add("forceHide");
      this.$emit("update:expandoff", []);
    },

    editItem(item) {
      this.$router.push(`/admin/tags/${item.id}/edit`);
    },

    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete listing!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deletePortal(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: {
                id: item.id,
              },
            });
            if (item.p24Id >= 1) {
              await this.$apollo.query({
                query: gql`
                  query ($p24id: String!) {
                    p24Withdraw(p24id: $p24id) {
                      p24id
                    }
                  }
                `,
                variables: {
                  p24id: item.p24Id,
                },
              });
            }

            if (response) {
              this.$swal(
                "Success!",
                "Listaing was successfully deleted",
                "success"
              );
              this.$apollo.queries.portals.refetch();
            }
          } catch (e) {}
        }
      });
    },
  },

  watch: {
    image: function (newVal, oldVal) {
      if (newVal) {
        this.createBase64Image(newVal);
      } else {
        this.base64 = null;
      }
    },

    refreshTable() {
      this.$apollo.queries.portals.refetch();
    },

    trigger() {
      this.$emit("update:trigger", this.trigger);
    },

    new_trigger() {
      if (this.new_trigger.includes("hq")) {
        this.gToggleTrigger(
          ".add-contact",
          "#contact-edit-block2",
          "#contact-edit-block2"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inline-icon {
  text-decoration: none;
}
.hq-sect-add.true #contact-edit-block {
  display: block !important;
}

.hq-sect-add #contact-edit-block.forceHide {
  display: none !important;
}

.hq-sect-add {
  margin-top: 30px;
}

.hq-sect-add .hq-ico-box {
  width: calc(100% - 100px);
  text-align: right;
  margin-bottom: 0px;
}

.mapLayer {
  position: relative;
}
.mapbox {
  padding: 0px !important;
  margin: 0px !important;
  background-color: #333;
  border-radius: 5px !important;
}

.googlemap {
  border-radius: 5px !important;
}
.property-header h1 {
  font-size: 35px;
  line-height: 30px;
  color: #2196f3;
  margin-bottom: 10px;
}

.property-header p {
  color: #000000;
  font-weight: 500;
}

.vs-dash-box {
  border: 1px solid #2196f3;
}

.vs-summary-box {
  border: 2px solid #2196f3;
}

.vs-summary-box h2 {
  font-size: 35px;
  line-height: 35px;
  color: #000000;
  font-weight: 500;
}

.vs-portfolio-list h2 {
  font-size: 18px;
  line-height: 30px;
  font-weight: 500;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: rgba(0, 0, 0, 0.54);
}

.v-list-item {
  min-height: 38px !important;
}

.text-h2 {
  line-height: 1em !important;
  font-weight: 500 !important;
}

/*container*/
#contact-edit-block {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  display: none !important;
}
#contact-edit-block.show {
  display: block !important;
  box-shadow: none;
}
#contact-edit-block #contact-edit-block form > .row {
  height: 83px;
  background: #e0e0e0;
  border-radius: 5px 5px 0px 0px;
  margin-bottom: 5px;
}
#contact-edit-block #contact-edit-block form > .row h2 {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
}
#contact-edit-block .contact-edit-fields {
  padding: 10px;
  background: #ebebeb;
}
#contact-edit-block .contact-edit-fields p {
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  padding: 0;
  margin-bottom: 0px;
}
#contact-edit-block
  .contact-edit-fields
  .v-input:not(.v-input--checkbox)
  .v-input__slot,
#contact-edit-block .contact-edit-fields input {
  background-color: #fff !important;
}

.showHQcreate #contact-edit-block2 {
  display: block !important;
}

.showHQcreate #contact-edit-block2.forceHide {
  display: none !important;
}

.showHQcreate #contact-edit-block {
  display: block !important;
}

.showHQcreate #contact-edit-block.forceHide {
  display: none !important;
}

/*header*/
#contact-edit-block form > .v-card__text {
  height: 83px;

  background: #e0e0e0;
  border-radius: 5px 5px 0px 0px;
}

#contact-edit-block form > .v-card__text h2 {
  margin-top: 20px;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
}

/*form box*/
#contact-edit-block .contact-edit-fields {
  padding: 15px 35px;
  margin-top: 2px;
  background: #ebebeb;
}

/*fields*/
#contact-edit-block .contact-edit-fields .col {
  padding: 20px;
}

#contact-edit-block .contact-edit-fields .col p {
  color: #000929;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 8px;
  font-size: 14px;
}

#contact-edit-block .contact-edit-fields .col .v-input .v-label--active {
  display: none;
}

#contact-edit-block .contact-edit-fields .col .v-text-field--outlined fieldset {
  border-width: -0px;
}

/*buttons*/
.form-action-block.row .col-4 {
  text-align: right;
}

.form-action-block.row button.v-btn:not(.prop-edit-btn) {
  min-height: 48px;
  margin-bottom: 10px;
  text-transform: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 141px;
  margin-right: 3px !important;
}

.form-action-block.row button.v-btn--outlined:not(.prop-edit-btn) {
  border-width: 3px;
}

/*override chevron*/
.mdi-menu-down::before {
  content: "\F035D";
}

.mdi-chevron-down::before {
  content: "\F0140";
}

.contact-edit-fields .mdi-menu-down::before {
  content: "\F0140" !important;
}

#contact-edit-block .contact-edit-fields {
  padding: 10px;
  background: #ebebeb;
}
#contact-edit-block .contact-edit-fields p {
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  padding: 0;
  margin-bottom: 0px;
}
#contact-edit-block
  .contact-edit-fields
  .v-input:not(.v-input--checkbox)
  .v-input__slot,
#contact-edit-block .contact-edit-fields input {
  background-color: #fff;
}

/*new  date*/
.fake-input {
  background-color: #fff !important;
  padding: 5px;
  min-height: 48px;
  display: flex;
  border-radius: 3px;
}

.fake-input > * {
  padding-left: 2px;
  padding-right: 2px;
  min-height: 40px;
}

.fake-input .mdi:before {
  padding-top: 10px;
}

.fake-input .v-select__slot {
  min-height: 40px;
}

.fake-input .v-text-field__details {
  display: none;
}

/*new email sub btn*/

.email-with-sub {
  display: flex;
  margin-bottom: 0px !important;
}
.email-with-sub .v-input--checkbox {
  margin-top: 0px !important;
  padding-top: 0px;
  margin-left: 20%;
}

.email-with-sub .v-input--checkbox .v-input--selection-controls__ripple {
  margin: 0 7px;
  height: 30px;
  width: 30px;
  top: calc(50% - 20px);
}
.email-with-sub .v-input__slot {
  margin-bottom: 0px;
}
.email-with-sub .v-messages.theme--light {
  min-height: 7px;
}

.email-with-sub .v-input--selection-controls.v-input .v-label {
  padding-bottom: 10px;
}

#contact-edit-block .for-odd-field .v-input__slot {
  min-height: 56px !important;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 1%) !important;
}

.for-odd-field.auto-field .v-text-field {
  padding-top: 0px;
  margin-top: 4px;
  border-radius: 4px;
}

.for-odd-field.auto-field
  .theme--light.v-text-field
  > .v-input__control
  > .v-input__slot:before {
  display: none;
}

.goback {
  margin-bottom: 10px;
  color: #5e5873;
}

.goback i {
  margin-right: 10px;
}

.hq-details-row {
  background-color: #fff;
  padding: 14px 25px 14px 25px;
  box-shadow: 0 4px 6px 0 rgba(32, 33, 36, 0.1);
  border-radius: 6px;
  margin-bottom: 20px;
}

button.v-btn {
  box-shadow: none;
}
.goback,
.hq-main-title-card .breadcrumb-block a {
  text-decoration: none;
  font-size: 16px;
  font-size: 16px;
  text-decoration: none;
  display: inline-block;
}

.hq-main-title-card {
  position: relative;
}

.floating-btn {
  position: absolute;
  right: 30px;
  top: 50px;
}

.hq-info-card.v-card {
  border-radius: 6px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.action-set {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.hq-info-card .inline-chips {
  display: inline-block;
  width: 61%;
  float: right;
  text-align: left;
}

.hq-main-title-card .breadcrumb-block a.breadcrumb-link {
  font-weight: 600;
}

.hq-main-title-card .heading {
  color: #100a55;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 7px;
}

.hq-info-card.plan div {
  margin-bottom: 7px !important;
  color: #6e6b7b;
}
.hq-info-card.plan span:not(.v-chip) {
  display: inline-block;
  min-width: 39%;
}
.hq-info-card.plan a {
  text-decoration: none;
  color: #6e6b7b;
}
.hq-info-card.plan div.action-set {
  margin-bottom: 0 !important;
}

.hq-info-card > b {
  margin-bottom: 12px;
  display: inline-block;
}

.hq-info-card.green,
.hq-info-card.red {
  padding: 16px;
  border-radius: 14px;
}

.hq-info-card.green div,
.hq-info-card.red div {
  margin-bottom: 12px;
}

.hq-info-card.red {
  background-color: rgba(244, 67, 54, 0.1) !important;
  color: #6e6b7b;
}

.hq-info-card.green {
  background-color: rgba(143, 199, 192, 0.3) !important;
  color: #6e6b7b;
}
.hq-info-card.red b,
.hq-info-card.green b {
  color: #022e41;
}

.hq-info-card.green div b,
.hq-info-card.red div b {
  float: right;
  display: inline-block;
}

//Tab styling
.hq-tabs.v-tab {
  font-size: 14px;
  height: 37px;
  width: auto !important;
  color: #5e5873;
  font-weight: 600;
}

.v-window-item.v-window-item--active {
  padding-top: 20px;
}

//notes
.v-application:has(.custom-half-page-dialog) {
  overflow: hidden;
}

.v-sheet.v-card.new-note-card {
  box-shadow: none !important;
  border: #e2f0ee solid 2px;
  padding: 8px;
  border-radius: 8px;
}
.notes-space {
  height: 90%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.notes-space .v-card {
  margin-top: auto;
}
.notes-space > b {
  color: #000929;
  font-weight: 600;
  opacity: 0.5;
  margin-bottom: 10px;
  display: block;
}

.single-note {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
}

.single-note p {
  color: #000929;
  margin-bottom: 10px;
}

.single-note span {
  color: #000929;
  opacity: 0.5;
  margin-bottom: 10px;
  display: block;
}
.single-note hr {
  border-color: rgba(0, 9, 41, 0.1);
  margin-bottom: 23px;
}

.new-note-card .v-card p,
.note-title p {
  font-weight: 600;
  opacity: 0.5;
  font-size: 16px;
  display: inline-block;
}

.note-title .v-btn {
  float: right;
  font-size: 14px;
  padding: 10px 20px;
}

.all-notes {
  height: 110px;
  overflow: auto;
  width: 100%;
}
.new-note-card.v-card {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.schedule-card-box.v-card {
  padding: 20px 40px !important;
  box-shadow: none !important;
}

.text-h5 {
  font-weight: 600;
}

.text-h2 {
  font-weight: 700;
}

.expand-filter-block .off,
.expand-filter-block .now-on .on {
  display: none;
}

.expand-filter-block .now-on .off {
  display: inline;
}
</style>
